import {
  LOGIN_ERROR,
  LOGIN_LOADING,
  LOGIN_SETUSUARIO,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  TOKEN_VALIDATION,
  TOKEN_VALIDATION_FAIL,
  TOKEN_VALIDATION_SUCCESS,
  LOGINTRAZA_ERROR,
  LOGINTRAZA_LOADING,
  LOGINTRAZA_SUCCESS,
  RESET_GLOBAL_CONTEXT,
  BIOMETRIC_AVAILABLE,
  BIOMETRIC_NOT_AVAILABLE,
  BIOMETRIC_ENABLED,
  BIOMETRIC_DISABLED,
  BIOMETRIC_LOGIN_SUCCESS,
  BIOMETRIC_LOGIN_ERROR,
} from "../ActionTypes";
import authInitialState from "../initialStates/authInitialState";

const auth = (state, { payload, type }) => {
  switch (type) {
    case LOGIN_LOADING:
      return {
        ...state,
        auth: {
          ...state.auth,
          error: false,
          loading: true,
        },
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        auth: {
          ...state.auth,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case LOGIN_ERROR:
      return {
        ...state,
        auth: {
          ...state.auth,
          error: payload,
          loading: false,
          data: null,
        },
      };

      
    case LOGINTRAZA_LOADING:
      return {
        ...state,
        authTraza: {
          ...state.authTraza,
          error: false,
          loading: true,
        },
      };
    case LOGINTRAZA_SUCCESS:
      return {
        ...state,
        authTraza: {
          ...state.authTraza,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case LOGINTRAZA_ERROR:
      return {
        ...state,
        authTraza: {
          ...state.authTraza,
          error: payload,
          loading: false,
          data: null,
        },
      };


    case LOGIN_SETUSUARIO:
      return {
        ...state,
        auth: {
          ...state.auth,
          error: false,
          loading: false,
          data: payload,
        },
      };

    case TOKEN_VALIDATION:
      return {
        ...state,
        auth: {
          ...state.auth,
          loadingMobile: true,
        },
      };
    case TOKEN_VALIDATION_SUCCESS:
      return {
        ...state,
        auth: {
          ...state.auth,
          loadingMobile: false,
        },
      };
    case TOKEN_VALIDATION_FAIL:
      return {
        ...state,
        auth: {
          ...state.auth,
          loadingMobile: false,
        },
      };
    case LOGOUT_USER:
      return authInitialState;
    case RESET_GLOBAL_CONTEXT:
      return authInitialState;

    // Biometric cases
    case BIOMETRIC_AVAILABLE:
      return {
        ...state,
        biometric: {
          ...state.biometric,
          isAvailable: true,
          biometryType: payload.biometryType,
        },
      };
    case BIOMETRIC_NOT_AVAILABLE:
      return {
        ...state,
        biometric: {
          ...state.biometric,
          isAvailable: false,
          biometryType: 0,
        },
      };
    case BIOMETRIC_ENABLED:
      return {
        ...state,
        biometric: {
          ...state.biometric,
          isEnabled: true,
          lastUser: payload?.dni || state.biometric.lastUser,
          error: null,
        },
      };
    case BIOMETRIC_DISABLED:
      return {
        ...state,
        biometric: {
          ...state.biometric,
          isEnabled: false,
          lastUser: null,
          error: null,
        },
      };
    case BIOMETRIC_LOGIN_SUCCESS:
      return {
        ...state,
        biometric: {
          ...state.biometric,
          error: null,
        },
      };
    case BIOMETRIC_LOGIN_ERROR:
      return {
        ...state,
        biometric: {
          ...state.biometric,
          error: payload,
        },
      };

    default:
      return state;
  }
};

export default auth;
